import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import "../../../../assets/css/customer/publicCustomerCss/Testimonial/testimonialreview.css";
import AppContext from "../../../../context/AppContext";

const TestimonialSlider = ({ autoPlayInterval = 4000 }) => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [displayCount, setDisplayCount] = useState(3);
  const [zoomedImg, setZoomedImg] = useState(null);
  const [imageErrors, setImageErrors] = useState({});
 const {baseUrl,imageBaseUrl}=useContext(AppContext);
  useEffect(() => {
    axios.get(
    `${baseUrl}/customer/get-customer-reviews`)
      .then((res) => {
        if (res.data.success) {
          console.log("Fetched reviews:", res.data.reviews);
          setTestimonials(res.data.reviews);
        }
      })
      .catch((err) => console.error("API Error:", err));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) setDisplayCount(1);
      else if (window.innerWidth <= 992) setDisplayCount(2);
      else setDisplayCount(3);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let interval;
    if (isAutoPlaying && testimonials.length > 0) {
      interval = setInterval(() => {
        setCurrentIndex((prev) =>
          prev + displayCount >= testimonials.length ? 0 : prev + displayCount
        );
      }, autoPlayInterval);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, currentIndex, displayCount, testimonials.length]);

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev + displayCount >= testimonials.length ? 0 : prev + displayCount
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? Math.max(0, testimonials.length - displayCount) : prev - displayCount
    );
  };

  const getVisibleTestimonials = () => {
    const items = [];
    for (let i = 0; i < displayCount; i++) {
      const index = (currentIndex + i) % testimonials.length;
      items.push(testimonials[index]);
    }
    return items;
  };

const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith("http")) return imagePath;

  const cleanPath = imagePath.replace(/^\/?storage\//, "");

  return `${imageBaseUrl}/${cleanPath}`;
};

  const handleImageError = (reviewId) => {
    setImageErrors(prev => ({ ...prev, [reviewId]: true }));
    console.log("Image failed to load for review:", reviewId);
  };

  if (testimonials.length === 0) return null;

  return (
    <>
      <section
        className="home-testimonial-section"
        onMouseEnter={() => setIsAutoPlaying(false)}
        onMouseLeave={() => setIsAutoPlaying(true)}
      >
        <Container>
          <div className="home-testimonial-header">
            <h2 className="home-testimonial-title">What Our Travelers Say</h2>
            <p className="home-testimonial-subtitle">
              Real experiences from travelers who explored Northern Pakistan
            </p>
          </div>

          <div className="home-testimonial-slider-container">
            <button className="home-testimonial-nav home-testimonial-prev" onClick={handlePrev}>
              <i className="fas fa-chevron-left"></i>
            </button>

            <div className="home-testimonial-grid">
              <Row>
                {getVisibleTestimonials().map((review, idx) => {
                  const imageUrl = getImageUrl(review.image);
                  const hasImageError = imageErrors[review.id];
                  
                  return (
                    <Col key={review.id || idx} md={12 / displayCount} className="mb-4">
                      <div className="home-testimonial-card">
                        <div className="home-testimonial-card-header">
                          <div className="home-testimonial-avatar-placeholder">
                            <i className="fas fa-user"></i>
                          </div>
                          <div className="home-testimonial-info">
                            <h4 className="home-testimonial-name">
                              {review.jjbooking?.jjcustomer?.cus_username || "—"}
                            </h4>
                            {/* Added Email - Like TestimonialPage */}
                            <p className="home-testimonial-email">
                              {review.jjbooking?.jjcustomer?.cus_email || "—"}
                            </p>
                            <div className="home-testimonial-rating">
                              {[...Array(5)].map((_, i) => (
                                <span key={i} className={i < review.rating ? "star-filled" : "star-empty"}>
                                  ★
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div className="home-testimonial-body">
                          <p className="home-testimonial-text">
                            {review.review_message || 'No message provided.'}
                          </p>
                        </div>

                        {review.image && !hasImageError && imageUrl && (
                          <div className="home-testimonial-img-wrap">
                            <div className="home-testimonial-img-thumb-wrap">
                              <img
                                src={imageUrl}
                                alt="Review"
                                className="home-testimonial-img-thumb"
                                onClick={() => setZoomedImg(imageUrl)}
                                onError={(e) => {
                                  console.log("Failed to load image:", imageUrl);
                                  handleImageError(review.id);
                                }}
                              />
                              <div
                                className="home-testimonial-img-overlay"
                                onClick={() => setZoomedImg(imageUrl)}
                              >
                                <i className="fas fa-search-plus"></i>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="home-testimonial-footer">
                          <span className="home-testimonial-date">
                            {new Date(review.created_at).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>

            <button className="home-testimonial-nav home-testimonial-next" onClick={handleNext}>
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>

          <div className="home-testimonial-dots">
            {Array.from({ length: Math.ceil(testimonials.length / displayCount) }).map((_, i) => (
              <button
                key={i}
                className={`home-testimonial-dot ${Math.floor(currentIndex / displayCount) === i ? "active" : ""}`}
                onClick={() => setCurrentIndex(i * displayCount)}
              />
            ))}
          </div>

          <div className="home-testimonial-view-more">
            <Link to="/testimonials" className="home-testimonial-view-btn">
              View More Stories <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </Container>
      </section>

      {zoomedImg && (
        <div className="home-testimonial-zoom-backdrop" onClick={() => setZoomedImg(null)}>
          <div className="home-testimonial-zoom-box" onClick={(e) => e.stopPropagation()}>
            <button className="home-testimonial-zoom-close" onClick={() => setZoomedImg(null)}>✕</button>
            <img src={zoomedImg} alt="Zoomed" className="home-testimonial-zoom-img" />
          </div>
        </div>
      )}
    </>
  );
};

export default TestimonialSlider;